<template lang="pug">
  div
    v-app-bar(dark app flat color="primary")
      v-app-bar-nav-icon(@click.stop="navDrawer = !navDrawer")
      v-toolbar-title Mighty Minds #[small {{appVersion}}]
      v-spacer
      div.pr-2
        v-menu(offset-y)
          template(v-slot:activator="{ on }")
            v-btn(
              icon
              v-on="on"
            )
              v-avatar(size="50")
                v-img(contain src="@/assets/avatar-placeholder.png")
          v-list(width="200")
            v-list-item(
              @click.stop=""
            )
              v-list-item-title Profile
            v-list-item(
              @click.stop="signOut"
            )
              v-list-item-title Sign out
    v-navigation-drawer(
      v-model="navDrawer"
      app
    )
      v-row
        v-col.text-center
          v-avatar(size="100").mb-3
            img(v-if="account.picURL" :src="account.picURL")
            img(src="@/assets/avatar-placeholder.png")
          h4 {{name.firstName}} {{name.lastName}}
          p.grey--text.text--darken-2 {{account.email}}
      v-divider
      v-list
        v-list-item-group(
          v-for="(route, i) in routes"
          :key="i"
        )
          v-list-item(:to="{ name: route.name, params: $route.params }")
            v-list-item-content
              v-list-item-title {{ route.text }}
    v-content
      router-view
</template>

<script>
import _ from 'lodash';

export default {
  mounted () {
    this.loadOrg();
  },
  data () {
    return {
      navDrawer: null,
      routes: [
        {
          name: 'info',
          text: 'Organization'
        },
        {
          name: 'scholars',
          text: 'Scholars'
        }
      ],
      menuItems: [
        'Profile',
        'Sign Out'
      ]
    };
  },
  computed: {
    account () {
      return this.$store.state.auth.account || {};
    },
    name () {
      return !_.isEmpty(this.account) ? this.account.name : {};
    },
    appVersion () {
      return this.$store.state.ui.packageVersion;
    }
  },
  methods: {
    async loadAccount (uid) {
      await this.$store.dispatch('auth/getAccount', uid);
    },
    async loadOrg () {
      await this.$store.dispatch('organization/getOrganization', { id: this.$route.params.id });
    },
    async signOut () {
      try {
        this.$setLoading(true);
        await this.$store.dispatch('auth/signout');
        this.$enqueueSnack('Signout success!');
      } catch (e) {
        console.error(e);
        this.$enqueueSnack(e);
      }
      this.$setLoading(false);
    }
  }
};
</script>
